import { V2, XY } from './V2.js';

export type pointer_type = {
    pos: XY;
    down: XY;
    hold: boolean;
    pressed: boolean;
    drag_target: string;
    dragging: boolean;
    force_touch: boolean;
    twist: number;
    roll: number;
    azimuth: number;
    altitude: number;
    pressure: number;
    type: string;
    update: (event: PointerEvent) => void;
}

export type inpt_type = {
    trigger: () => void;
    keys: Record<string, boolean>;
    pan: { x: number, y: number, z: number };
    active_pointers: Map<number, XY>;
    pointers: pointer_type[];
    pointer: pointer_type;
    min_drag: number;
    on_press: (cb: () => void) => () => void;
    on_release: (cb: () => void) => () => void;
    //fires once per physical key-down (auto-repeat suppressed) for the given key; returns an unsubscribe fn.
    on_key: (key: string, cb: () => void) => () => void;
    run: () => void;
}

export function inpt_manager(Scrn: any, Pnts: any, Plls: any): inpt_type {

    //pointer position updated
    const min_drag = 0.01;

    const pointer = {
        pos: { x: 0, y: 0 } as XY,
        down: { x: 0, y: 0 } as XY,
        hold: false,
        pressed: false,
        drag_target: "",
        dragging: false,
        force_touch: false,
        roll: 0,
        azimuth: 0,
        altitude: 0,
        pressure: 0,
        type: "mouse",
        update: function (event) { //das brauchts weil diese Inpt funktion sich manchmal später updated als die Funktion die darauf zugreift
            (this.hold) ? move(event) : down(event);
        }
    } as pointer_type;

    //callbacks
    const press_cbs: (() => void)[] = [];
    const release_cbs: (() => void)[] = [];

    //long press detection
    let down_time = 0;
    const force_threshold = 300;

    //drag handling
    const pointer_up = function (): void {
        if (pointer.dragging) {
            console.log("DRAG STOP", pointer.drag_target);
            Plls.kill("draggery");
            pointer.dragging = false;
        }
        pointer.hold = false;
        pointer.drag_target = "";
        for (let i = 0; i < release_cbs.length; i++) release_cbs[i]();
    }

    //active pointers (tracked per pointerId for multi-touch)
    const active_pointers = new Map<number, XY>();

    //global listners

    const is_input = function (e: Event) { //checkt ob ein element input oder dropdown ist
        return (e.target instanceof HTMLInputElement || e.target instanceof HTMLSelectElement);
    }

    const down = function (event: PointerEvent) {
        const pos = Scrn.to_twrk({ x: event.clientX, y: event.clientY });
        V2.set(pointer.pos, pos);
        V2.set(pointer.down, pos);
        pointer.hold = true;
        pointer.pressed = true;
        pointer.force_touch = false;
        const pen_down = (window as any).__penpen_roll;
        pointer.roll = typeof pen_down === 'number' ? pen_down : 0; //pen down goes from -Math.PI to +Math.PI
        pointer.azimuth = (event as any).azimuthAngle || 0;
        pointer.altitude = (event as any).altitudeAngle || 0;
        pointer.pressure = event.pressure || 0;
        pointer.type = event.pointerType;
        down_time = event.timeStamp;
        active_pointers.set(event.pointerId, { x: pos.x, y: pos.y });
        for (let i = 0; i < press_cbs.length; i++) press_cbs[i]();
    }
    document.addEventListener("pointerdown", (event): void => {
        down(event);
        if (!is_input(event)) event.preventDefault();
    }, { passive: false });
    const move = function (event: PointerEvent) {
        const pos = Scrn.to_twrk({ x: event.clientX, y: event.clientY });
        V2.set(pointer.pos, pos);
        const pen_move = (window as any).__penpen_roll;
        pointer.roll = typeof pen_move === 'number' ? pen_move : 0; //pen down goes from -Math.PI to +Math.PI
        pointer.azimuth = (event as any).azimuthAngle || 0;
        pointer.altitude = (event as any).altitudeAngle || 0;
        pointer.pressure = event.pressure || 0;
        pointer.type = event.pointerType;
        if (active_pointers.has(event.pointerId)) {
            active_pointers.set(event.pointerId, { x: pos.x, y: pos.y });
        }
        if (!is_input(event)) event.preventDefault();
    }
    document.addEventListener("pointermove", (event: PointerEvent): void => {
        move(event);
    }, { passive: false });
    //capture phase so force_touch is set before element handlers
    document.addEventListener("pointerup", (event): void => {
        pointer.force_touch = (event.timeStamp - down_time) >= force_threshold;
    }, true);
    document.addEventListener("pointerup", (event): void => {
        pointer_up();
        active_pointers.delete(event.pointerId);
        if (!is_input(event)) event.preventDefault();
    }, { passive: false });
    document.addEventListener("pointercancel", (event): void => {
        pointer_up();
        active_pointers.delete(event.pointerId);
        if (!is_input(event)) event.preventDefault();
    }, { passive: false });
    //OS-stolen gestures (iOS edge swipes, system dialogs) can swallow pointerup; release on blur/hide
    window.addEventListener("blur", () => { pointer_up(); active_pointers.clear(); });
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") { pointer_up(); active_pointers.clear(); }
    });

    //panning listner
    window.addEventListener('wheel', function (ev: WheelEvent) {
        ev.preventDefault();
        if (ev.ctrlKey) {
            self.pan.z -= ev.deltaY * 0.005;
            self.pan.z = Math.max(-0.95, Math.min(self.pan.z, 3));//clamp zoom range
        } else {
            self.pan.x -= ev.deltaX * 2 * 0.001;
            self.pan.y -= ev.deltaY * 2 * 0.001;
        }
    }, { passive: false });

    //damit user nicht double tap zoom machen kann
    document.addEventListener('touchstart', e => {
        if (!is_input(e)) e.preventDefault();
    }, { passive: false })

    const keys: Record<string, boolean> = {};
    const key_cbs: Record<string, (() => void)[]> = {};   //per-key keydown subscribers (edge-triggered).
    document.addEventListener('keydown', e => {
        if (e.repeat) return;   //OS auto-repeat while held: keep the state set, but don't re-fire the edge callbacks.
        keys[e.key] = true;
        const cbs = key_cbs[e.key];
        if (cbs) for (let i = 0; i < cbs.length; i++) cbs[i]();
    });
    document.addEventListener('keyup', e => { keys[e.key] = false; });

    const self = {
        trigger: function () { },
        keys: keys,
        active_pointers: active_pointers,
        pointers: [],
        pan: { x: 0, y: 0, z: 0 }, //z for zoom
        pointer: pointer,
        min_drag: min_drag,
        on_press: function (cb: () => void) { press_cbs.push(cb); return () => { const i = press_cbs.indexOf(cb); if (i !== -1) press_cbs.splice(i, 1); }; },
        on_release: function (cb: () => void) { release_cbs.push(cb); return () => { const i = release_cbs.indexOf(cb); if (i !== -1) release_cbs.splice(i, 1); }; },
        on_key: function (key: string, cb: () => void) { (key_cbs[key] ??= []).push(cb); return () => { const a = key_cbs[key]; if (!a) return; const i = a.indexOf(cb); if (i !== -1) a.splice(i, 1); }; },
        pen_roll: false, //muss ich noch in xcode machen
        run: function () {
            if (!pointer.dragging && pointer.drag_target && V2.get.distance(pointer.down, pointer.pos) > min_drag) {
                const target_point = Pnts.get(pointer.drag_target);
                if (target_point) {
                    console.log("DRAG START", pointer.drag_target);
                    Plls.make({ id: "draggery", a: pointer, b: target_point, distance: 0, stiffness: 0.1, offset: V2.new.sub(target_point.pos, pointer.pos) });
                    pointer.dragging = true;
                    pointer.drag_target = "";
                } else {
                    //console.log("DRAG TARGET NOT FOUND");
                }
            }
            pointer.pressed = false;
        }
    }
    return self;
};